import {
    ColorNordicGrey4,
    BorderRadiusMedium,
    ColorNordicGrey2,
    Spacing16,
    Spacing8
} from 'autogen/design-tokens/tokens';
import { css } from 'styled-components';

// Only used for tables directly embedded into the product description. (Not a React table)
const descriptionTableStyling = css`
    table:not([class*='StyledTable']) {
        padding: ${Spacing16};
        width: 100%;
        background-color: ${ColorNordicGrey4};
        border-radius: ${BorderRadiusMedium};
        border-collapse: separate;
        border-spacing: 0;
        margin: ${Spacing16} 0;

        tr {
            td,
            th {
                padding: ${Spacing8} 0;

                &:last-child {
                    text-align: right;
                }

                &:first-child {
                    text-align: left;
                }
            }

            th {
                font-weight: bold;
                border-bottom: 1px solid ${ColorNordicGrey2};
            }
        }
    }
`;

export default descriptionTableStyling;
